export default __webpack_public_path__ + "static/media/overwhelm5.aeee85d7.png";